import { createTheme, Theme } from '@mui/material/styles';
import palette from './palette';
import components from './components';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true; // removes the `xs` breakpoint
    sm: true;
    md: true;
    lg: true;
    xl: true;
    dialogSmall: true; // adds the `mobile` breakpoint

  }
}

const theme: Theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      dialogSmall: 700,
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: '"Lato", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  palette,
  components,
});

export default theme;
